export default __webpack_public_path__ + "static/media/banner.ee783d09.jpg";